import { render, staticRenderFns } from "./InstallationStatusChip.vue?vue&type=template&id=2b3f030a&"
import script from "./InstallationStatusChip.vue?vue&type=script&lang=js&"
export * from "./InstallationStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports